<!-- param: viewMode-控制显示，id-控制数据加载，mode-控制button加载 -->
<template>
  <el-container
    v-loading="loading"
  >
    <!-- 右侧菜单 -->
    <el-container>
      <!-- 功能按钮组 -->
      <el-header height="42px">
        <span v-if="viewMode == 'list'" class="ik-list-title">
          <span class="svg-container ik-list-icon">
            <svg-icon icon-class="database" />
          </span>
          <span>数据列表</span>
        </span>
        <!-- 列表页菜单 -->
        <el-button-group v-if="viewMode === 'list'" class="ik-list-menu">
          <el-button class="ik-list-menu-btn" size="medium" @click="listCreateBtn">新增</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listUpdateBtn">修改</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDetailsBtn">详情</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="listDeleteBtn">删除</el-button>
        </el-button-group>
        <!-- 信息页菜单 -->
        <el-button-group v-if="viewMode === 'info'" class="ik-list-menu">
          <!-- 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式 -->
          <el-button v-if="mode == 'edit' || mode == 'details' " class="ik-list-menu-btn" size="medium" @click="infoCreateBtn">新增</el-button>
          <el-button v-if="mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoUpdateBtn">修改</el-button>
          <el-button v-if="mode == 'edit' || mode == 'details'" class="ik-list-menu-btn" size="medium" @click="infoCopyBtn">复制</el-button>
          <el-button v-if="mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoDetailsBtn">详情</el-button>
          <el-button v-if="mode == 'add' || mode == 'edit'" class="ik-list-menu-btn" size="medium" @click="infoSaveBtn">保存</el-button>
          <el-button class="ik-list-menu-btn" size="medium" @click="infoCancelBtn">取消</el-button>
        </el-button-group>
      </el-header>
      <el-main>
        <!-- 表头 -->
        <el-form
          v-if="viewMode == 'info'"
          id="ik-info-head"
          v-model="data.head"
          class="ik-info-head"
          :inline="true"
          label-width="120px"
          :disabled="mode == 'details'"
          @validate="validate"
        >
          <el-row>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_userCode'"
                v-model="data.head['userCode']"
                url="base/user/user/user/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="userCode"
                name="用户编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_userName'"
                v-model="data.head['userName']"
                code="userName"
                name="用户名称"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-select
                :ref="'input_typeSign'"
                v-model="searcher['typeSign']"
                code="typeSign"
                name="类型标识"
                default-value=""
                key-field="key"
                value-field="value"
                :options="toJson(jsonStr.typeSign)"
                :disabled="false"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_motionCode'"
                v-model="data.head['motionCode']"
                url="health/content/content/motion/find/findPagination"
                :filed-list="[
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="motionCode"
                name="运动项目编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_motionName'"
                v-model="data.head['motionName']"
                code="motionName"
                name="运动项目名称"
                default-value=""
                :edit="false"
                disabled
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-data-popup
                :ref="'input_motionVideoCode'"
                v-model="data.head['motionVideoCode']"
                url="health/content/content/motionvideo/find/findPagination"
                :filed-list="[
                  { code: 'id', name: 'ID' },
                  { code: 'code', name: '编码' },
                  { code: 'name', name: '名称' }
                ]"
                search-key="name"
                :searcher="{}"
                code="motionVideoCode"
                name="打卡视频编码"
                default-value=""
                :min-length="0"
                :max-length="20"
                :disabled="false"
                :require="true"
                @onFieldChange="onFieldChange"
                @onPopupClick="headPopupClick"
              />
            </el-col>
            <el-col :span="6">
              <ik-form-text
                :ref="'input_motionVideoName'"
                v-model="data.head['motionVideoName']"
                code="motionVideoName"
                name="打卡视频名称"
                default-value=""
                :edit="false"
                disabled
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <IkFormDate
                :ref="'input_recordDate'"
                v-model="data.head['recordDate']"
                code="recordDate"
                name="记录日期"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
            <el-col :span="6">
              <IkFormDatetime
                :ref="'input_recordTime'"
                v-model="data.head['recordTime']"
                code="recordTime"
                name="记录时间"
                default-value=""
                :edit="false"
                @onFieldChange="onFieldChange"
              />
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询区 -->
        <div class="querybg">
          <el-collapse
            v-if="viewMode == 'list'"
            v-model="searcherActive"
            class="ik-list-searcher"
            accordion
          >
            <el-collapse-item class="ik-list-searcher-item" title="" name="1">
              <!-- 标题栏 -->
              <template slot="title">
                <div class="ik-list-searcher-item-titles">
                  <span class="svg-container ik-list-icon">
                    <svg-icon icon-class="search" />
                  </span>
                  查询条件
                </div>
              </template>
              <!-- 查询菜单 -->
              <el-form
                id="ik-info-head"
                v-model="searcher"
                class="ik-info-head"
                :inline="true"
                label-width="120px"
                :disabled="false"
              >
                <el-row>

                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userCode'"
                      v-model="searcher['userCode']"
                      code="userCode"
                      name="用户编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-text
                      :ref="'input_userName'"
                      v-model="searcher['userName']"
                      code="userName"
                      name="用户名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <ik-form-select
                      :ref="'input_typeSign'"
                      v-model="searcher['typeSign']"
                      code="typeSign"
                      name="类型标识"
                      default-value="1"
                      key-field="key"
                      value-field="value"
                      :options="toJson(jsonStr.typeSign)"
                      :edit="false"
                    />
                  </el-col>
                  <el-col>
                    <ik-form-text
                      :ref="'input_motionCode'"
                      v-model="searcher['motionCode']"
                      code="motionCode"
                      name="运动项目编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col>
                    <ik-form-text
                      :ref="'input_motionName'"
                      v-model="searcher['motionName']"
                      code="motionName"
                      name="运动项目名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col>
                    <ik-form-text
                      :ref="'input_motionVideoName'"
                      v-model="searcher['motionVideoName']"
                      code="motionVideoName"
                      name="打卡视频编码"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col>
                    <ik-form-text
                      :ref="'input_motionVideoName'"
                      v-model="searcher['motionVideoName']"
                      code="motionVideoName"
                      name="打卡视频名称"
                      default-value=""
                      :edit="false"
                    />
                  </el-col>
                  <el-col :span="6">
                    <IkFormDate
                      :ref="'input_minRecordDate'"
                      v-model="data.head['minRecordDate']"
                      code="minRecordDate"
                      name="最早记录日期"
                      default-value=""
                      :edit="false"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <IkFormDate
                      :ref="'input_maxRecordDate'"
                      v-model="data.head['maxRecordDate']"
                      code="maxRecordDate"
                      name="最晚记录日期"
                      default-value=""
                      :edit="false"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <IkFormDatetime
                      :ref="'input_minRecordStartTime'"
                      v-model="data.head['minRecordStartTime']"
                      code="minRecordStartTime"
                      name="最早记录开始时间"
                      default-value=""
                      :edit="false"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <IkFormDatetime
                      :ref="'input_minRecordTime'"
                      v-model="data.head['minRecordTime']"
                      code="minRecordTime"
                      name="最早记录时间"
                      default-value=""
                      :edit="false"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                  <el-col :span="6">
                    <IkFormDatetime
                      :ref="'input_maxRecordTime'"
                      v-model="data.head['maxRecordTime']"
                      code="maxRecordTime"
                      name="最晚记录时间"
                      default-value=""
                      :edit="false"
                      @onFieldChange="onFieldChange"
                    />
                  </el-col>
                </el-row>
              </el-form>
              <!-- 操作按钮 -->
              <div class="query-class">
                <div class="query-btn-warp">
                  <el-button type="primary" size="small" @click="searchBtn">查询</el-button>
                  <el-button type="primary" size="small" @click="resetBtn">重置</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <!-- 数据表 -->
        <el-table
          v-if="viewMode == 'list'"
          ref="table"
          v-loading="listLoading"
          :data="tableData"
          element-loading-text="加载中..."
          :stripe="true"
          :border="true"
          :fit="true"
          class="ik-list-table"
          height="calc(100% - 50px)"
          :header-row-class-name="'ik-list-table-header-row'"
          :header-cell-class-name="'ik-list-table-header-cell'"
          :row-class-name="'ik-list-table-body-row'"
          :cell-class-name="'ik-list-table-body-cell'"
          :highlight-current-row="true"
          @row-click="rowClick"
        >

          <ik-column-text
            code="userCode"
            name="用户编码"
            :edit="false"
          />
          <ik-column-text
            code="userName"
            name="用户名称"
            :edit="false"
          />
          <ik-column-select
            code="typeSign"
            name="类型标识"
            :edit="false"
            key-field="key"
            value-field="value"
            :options="toJson(jsonStr.typeSign)"
          />
          <ik-column-text
            code="motionCode"
            name="运动项目编码"
            :edit="false"
          />
          <ik-column-text
            code="motionName"
            name="运动项目名称"
            :edit="false"
          />
          <ik-column-text
            code="motionVideoCode"
            name="打卡视频编码"
            :edit="false"
          />
          <ik-column-text
            code="motionVideoName"
            name="打卡视频名称"
            :edit="false"
          />
          <ik-column-date
            code="recordDate"
            name="记录日期"
            :edit="false"
          />
          <ik-column-datetime
            code="recordTime"
            name="记录时间"
            :edit="false"
          />
        </el-table>
      </el-main>
      <!-- 分页组件 -->
      <el-footer height="40px">
        <ik-pagination
          v-if="viewMode == 'list'"
          ref="ik_list_pagination"
          :page-no="pagination.pageNo"
          :page-size="pagination.pageSize"
          :total-count="pagination.totalCount"
          @pageChangeMethod="pageChange"
        />
        <el-row v-else class="ik-list-pagination" :gutter="0">
          <el-col :span="6" class="ik-list-enterprise-info" :offset="12">
            <span style="float: left"> 导萃门诊管理系统 </span>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>
<script>
// 表单组件
import IkFormText from '@/components/ik/form/input/IkFormText'
import IkFormSelect from '@/components/ik/form/input/IkFormSelect'
import IkFormDataPopup from '@/components/ik/form/input/IkFormDataPopup'
import IkFormDate from '@/components/ik/form/input/IkFormDate'
import IkFormDatetime from '@/components/ik/form/input/IkFormDatetime'
import IkColumnText from '@/components/ik/table/ikColumn/IkColumnText'
import IkPagination from '@/components/ik/pagination/IkPagination'
import IkColumnDate from '@/components/ik/table/ikColumn/IkColumnDate'
import IkColumnSelect from '@/components/ik/table/ikColumn/IkColumnSelect'
import IkColumnDatetime from '@/components/ik/table/ikColumn/IkColumnDatetime'
import store from '@/store'

import { getById, findPage, save, update, remove, postData } from '@/api/ik/data/dataApi'
export default {
  components: {
    // 表单组件
    IkFormText,
    IkFormDataPopup,
    IkFormSelect,
    IkFormDate,
    IkColumnText,
    IkPagination,
    IkColumnDate,
    IkColumnDatetime,
    IkFormDatetime,
    IkColumnSelect
  },
  props: {
  },
  data() {
    return {
      // ===== ===== ===== ===== 权限字段 ===== ===== ===== =====
      storeId: store.getters['user/getStoreId'],
      storeCode: store.getters['user/getStoreCode'],
      // ===== ===== ===== ===== 全局属性 ===== ===== ===== =====
      // 后台接口路径
      bgPath: 'health/health/health/sportrecord',
      // Web路径
      webPath: 'health/SportRecord',
      // 标识字段JSON
      jsonStr: {
        typeSign: '[{"key": "1", "value": "早间"}, {"key": "2", "value": "晚间"}]',
        wineTypeSign: '[{"key": "1", "value": "啤酒为主"}]',
        foushi: '[{"key": "0", "value": "否"}, {"key": "1", "value": "是"}]',
        sleepSign: '[{"key": "1", "value": "正常"}, {"key": "2", "value": "不好"}]',
        youwu: '[{"key": "0", "value": "无"}, {"key": "1", "value": "有"}]',
        foodTypeSign: '[{"key": "1", "value": "早餐"}, {"key": "2", "value": "早加餐"}, {"key": "3", "value": "午餐"}, {"key": "4", "value": "午加餐"}, {"key": "5", "value": "晚餐"}, {"key": "6", "value": "晚加餐"}]',
        effectiveSign: '[{"key": "0", "value": "无效"}, {"key": "1", "value": "有效"}]'
      },
      // 界面模式  info - 信息页, list - 列表页
      viewMode: '',
      // 编辑模式  add - 新增模式, edit - 编辑模式, details - 详情模式, list - 列表模式
      mode: '',
      // 加载标识、列表加载标识
      loading: false,
      listLoading: false,
      // ===== ===== ===== ===== 列表页属性 ===== ===== ===== =====
      // 查询器是否激活
      searcherActive: "0",
      searcher: {},
      // 列表页数据
      tableData: [],
      // 当前选中行
      activeRow: {},
      // 分页器
      pagination: {
        pageNo: 1,
        pageSize: 20,
        totalCount: 2
      },
      // ===== ===== ===== ===== 信息页属性 ===== ===== ===== =====
      // 当前数据id
      id: 0,
      // 当前数据
      data: {
        head: {},
        body: {}
      },
      // 子表清单
      bodyMap: [],
      // 主表验证器
      validate: [],
      // 子表验证器
      bodyValidate: [],
      // 当前子表
      activeTab: '',
      verify: {
        head: {},
        body: {}
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // 获取视图模式
    this.viewMode = this.$route.params.viewMode || "list"
    this.mode = this.$route.params.mode || "list"
    this.id = this.$route.query.id || 0
    // 初始化界面，设置模式取值
    if (this.mode === "list") {
      this.viewMode = "list"
    } else {
      this.viewMode = "info"
    }
    // 列表页进入时的处理
    if (this.viewMode === "list") {
      this.find()
    } else if (this.viewMode === "info") {
      if (this.id !== 0) {
        this.get(this.id)
      }
    }
  },
  methods: {
    // ===== ===== ===== ===== 工具方法 ===== ===== ===== =====
    // 工具方法 - 转为json
    toJson(jsonStr) {
      return JSON.parse(jsonStr)
    },
    // ===== ===== ===== ===== 工具栏按钮 ===== ===== ===== =====
    listCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 列表页编辑按钮点击
    listUpdateBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        this.$router.push({ path: '/business/' + this.webPath + '/info/edit', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页详情按钮点击
    listDetailsBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要编辑的行!'
        })
      } else {
        // 修改为详情模式
        this.$router.push({ path: '/business/' + this.webPath + '/info/details', query: { id: $this.activeRow.id }})
      }
    },
    // 列表页删除按钮点击
    listDeleteBtn() {
      // 是否选择行
      const $this = this
      if ($this.activeRow.id === undefined) {
        $this.$message({
          type: 'warning',
          message: '请选择需要删除的行!'
        })
      } else {
        // 问询是否删除
        this.$confirm('删除ID为' + $this.activeRow.id + '的数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delete($this.activeRow.id)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    // 信息页创建按钮点击
    infoCreateBtn() {
      this.$router.push({ path: '/business/' + this.webPath + '/info/add' })
    },
    // 信息页编辑按钮点击
    infoUpdateBtn() {
      // 修改为编辑模式
      this.mode = "edit"
    },
    // 复制按钮点击事件
    infoCopyBtn() {
      // 修改id为控制
      this.data.head.id = 0
      // 修改为编辑模式
      this.mode = "edit"
    },
    infoDetailsBtn() {
      // 修改为编辑模式
      this.mode = "details"
      this.get(this.data.head.id)
    },
    // 保存按钮点击事件
    infoSaveBtn() {
      this.saveOrUpdate()
    },
    // 取消按钮点击事件
    infoCancelBtn() {
      // 修改为详情模式
      this.$router.push({ path: '/business/' + this.webPath + '/list/list' })
    },
    // 查询
    searchBtn() {
      this.find()
    },
    // 重置
    resetBtn() {
      this.searcher = {}
      this.find()
    },
    // ===== ===== ===== ===== 信息页表格行维护 ===== ===== ===== =====
    // 新增行按钮
    addRow(currt, index) {
      this.data.body[currt].splice(index + 1, 0, {})
    },
    // 删除行按钮
    delRow(currt, index) {
      this.data.body[currt].splice(index, 1)
    },
    // ===== ===== ===== ===== 列表页表格点击 ===== ===== ===== =====
    // 行点击事件
    rowClick(row, column, event) {
      this.activeRow = row
    },
    // 字段变更事件
    onFieldChange(fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.$set(this.data.head, fieldName, newValue)
      this.verify.head['head' + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', fieldName, oldValue, newValue)
    },
    // 子表字段变更事件
    onBodyFieldChange(line, fieldName, oldValue, newValue, errorSign, errorMessage) {
      // 处理格式验证
      this.verify.body['item1' + '-' + line + '-' + fieldName] = errorSign
      this.$emit('onFieldChange', line, fieldName, oldValue, newValue)
    },
    // 分页器数据变更
    pageChange(pageNo, pageSize) {
      // 修改分页数据
      this.pagination.pageNo = pageNo
      this.pagination.pageSize = pageSize
      // 刷新数据
      this.find()
    },
    // 开窗点击事件
    searchPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "allergyDirectoryCode") {
        this.searcher["allergyDirectoryCode"] = row.code
      } else if (code === "allergyDictionaryCode") {
        this.searcher["allergyDictionaryCode"] = row.code
      } else if (code === "storeCode") {
        this.searcher["storeCode"] = row.code
      }
    },
    // 开窗点击事件
    headPopupClick(code, row) {
      // 如果是药品字典点击
      if (code === "userCode") {
        this.data.head["userId"] = row.id
        this.data.head[code] = row.code
        this.data.head["userName"] = row.name
      } else if (code === "motionCode") {
        this.data.head["motionId"] = row.id
        this.data.head[code] = row.code
        this.data.head["motionName"] = row.name
      } else if (code === "motionVideoCode") {
        this.data.head["motionVideoId"] = row.id
        this.data.head[code] = row.code
        this.data.head["motionVideoName"] = row.name
      }
    },
    // ===== ===== ===== ===== 接口通讯方法 ===== ===== ===== =====
    // 保存或修改数据
    saveOrUpdate() {
      const $this = this
      // 验证
      for (const headInd in this.verify.head) {
        if (this.verify.head[headInd]) {
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      for (const bodyInd in this.verify.body) {
        if (this.verify.body[bodyInd]) {
          console.log(this.verify.body[bodyInd])
          $this.$message({ type: 'error', message: '数据格式异常' })
          console.log(this.verify)
          return
        }
      }
      if ($this.data.head.id) {
        update($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      } else {
        save($this.bgPath, $this.data).then(response => {
          // 设置ID
          $this.id = response.data
          // 刷新数据
          $this.get(response.data)
          $this.$message({
            type: 'success',
            message: '数据已保存!'
          })
          $this.viewMode = "info"
          $this.mode = "details"
        })
      }
    },
    // 删除数据
    delete(id) {
      const $this = this
      remove($this.bgPath, id).then(response => {
        $this.$message({
          type: 'warning',
          message: '数据已删除!'
        })
        $this.find()
      })
    },
    // 获取数据
    get(id) {
      const $this = this
      // 获取树组件数据
      getById($this.bgPath, id).then(response => {
        $this.data = response.data
      })
    },
    // 查询数据
    find() {
      const $this = this
      $this.listLoading = true
      // 获取树组件数据
      $this.searcher.storeCode = $this.storeCode
      findPage($this.bgPath, $this.searcher, $this.pagination.pageSize, $this.pagination.pageNo).then(response => {
        // 设置表格数据
        $this.tableData = response.data.list
        // 设置分页器
        $this.pagination.totalCount = response.data.totalCount
        // 设置加载完成
        $this.listLoading = false
      }).catch(() => {
        $this.listLoading = false
      })
    },
    // 启用词典
    listOpenBtn() {
      const $this = this
      postData(this.bgPath + "/do/enabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已启用!'
        })
      })
    },
    // 停用词典
    listCloseBtn() {
      const $this = this
      postData(this.bgPath + "/do/disabledic", { "storeCode": $this.storeCode, "dictionaryCode": this.activeRow.allergyDictionaryCode }).then(res => {
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已禁用!'
        })
      })
    },
    // 同步词典
    listSyncBtn() {
      const $this = this
      $this.listLoading = true
      postData(this.bgPath + "/do/syncdic", { "storeCode": $this.storeCode }).then(res => {
        $this.listLoading = false
        $this.find()
        $this.$message({
          type: 'success',
          message: '数据已同步!'
        }).catch(() => {
          $this.listLoading = false
        })
      })
    }
  }
}
</script>
<style lang="scss" >
@import "~@/styles/listinfo.scss";
.data-directory-tabs-info{height:calc(100% - 60px);}
.data-directory-tabs-info .el-tabs__content{height:calc(100% - 53px);overflow:auto;min-height:350px;}
</style>
